"use strict";

/**
 * @module Conversation
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CIDSerialiser = exports.CIDSerialiserClass = void 0;
var conversation_id_1 = require("./../conversation/conversation-id");
var Codec = require("./../io/codec");
/**
 * A Serialiser for {@link ConversationId}s
 */
var CIDSerialiserClass = /** @class */function () {
  function CIDSerialiserClass() {}
  /**
   * @inheritdoc
   */
  CIDSerialiserClass.prototype.read = function (bis) {
    return new conversation_id_1.ConversationId(Codec.readInt64(bis));
  };
  /**
   * @inheritdoc
   */
  CIDSerialiserClass.prototype.write = function (bos, cid) {
    Codec.writeInt64(bos, cid.val);
  };
  return CIDSerialiserClass;
}();
exports.CIDSerialiserClass = CIDSerialiserClass;
/**
 * The {@link CIDSerialiser} singleton
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
exports.CIDSerialiser = new CIDSerialiserClass();